import { render } from "./charts-table.vue?vue&type=template&id=520120a4&scoped=true&ts=true"
import script from "./charts-table.vue?vue&type=script&lang=ts"
export * from "./charts-table.vue?vue&type=script&lang=ts"

import "./charts-table.vue?vue&type=style&index=0&id=520120a4&lang=scss&scoped=true"
import "./charts-table.vue?vue&type=style&index=1&id=520120a4&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-520120a4"]])

export default __exports__